import { useBehavioralTrackingProps as _useBehavioralTrackingProps } from '../../../../../core/hooks/useBehavioralTrackingProps.js';
import { useTooltipActions } from '../../../../core/components/overlay-tooltip/useTooltipActions.js';
import { ChartToolbarRenderer } from '../../../../core/components/toolbar/ChartToolbarRenderer.js';
import { getA11yToolbarConfig } from '../../../../core/utils/zoom.js';
import { useMeterBarToolbarConfig } from '../../context/MeterBarToolbarConfigContext.js';

export const MeterBarChartToolbar = () => {
  const toolbarConfig = useMeterBarToolbarConfig();
  const isToolbarEnabled =
    !toolbarConfig?.hidden && !!toolbarConfig?.intents?.length;
  const behaviorTrackingProps = _useBehavioralTrackingProps(
    toolbarConfig ?? {},
  )[0];
  const { reset } = useTooltipActions();

  if (!isToolbarEnabled) {
    return null;
  }

  return (
    <ChartToolbarRenderer
      visible={isToolbarEnabled}
      placement={toolbarConfig.placement}
      collapsed={toolbarConfig.collapsed}
      draggable={false}
      initialA11yState={getA11yToolbarConfig({
        intent: !!toolbarConfig.intents,
      })}
      menuDisplayMode="never"
      intents={toolbarConfig.intents}
      isDownloadEnabled={false}
      toolbarDisplayMode="inline"
      overlayClassName=""
      onToggleMenu={(isOpen) => {
        if (isOpen) {
          reset();
        }
      }}
      {...behaviorTrackingProps}
    />
  );
};

MeterBarChartToolbar['displayName'] = 'MeterBarChartToolbar';
